import React from 'react';
import PropTypes from 'prop-types';
import { X, Copy } from 'lucide-react';

const Tabs = ({ tabs, activeTabId, onTabSwitch, onTabClose, onCreateTabFromFilter }) => {
  return (
    <div className="flex items-center bg-slate-800 border-b border-slate-700 overflow-x-auto no-scrollbar">
      {tabs.map(tab => {
        const isActive = tab.id === activeTabId;
        return (
          <div
            key={tab.id}
            onClick={() => onTabSwitch(tab.id)}
            className={`tab-btn px-4 py-2 text-sm cursor-pointer border-r border-slate-700 flex items-center justify-between gap-2 group ${
              isActive
                ? 'active bg-slate-900 border-b-2 border-blue-500 text-white'
                : 'text-slate-400 hover:text-white hover:bg-slate-700'
            }`}
          >
            <span className="truncate">{tab.name}</span>
            {tabs.length > 1 && (
              <X
                size={12}
                className="opacity-0 group-hover:opacity-100 hover:text-red-400 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onTabClose(tab.id);
                }}
              />
            )}
          </div>
        );
      })}

      {/* Tab from Filter Button */}
      <button
        onClick={onCreateTabFromFilter}
        className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded text-sm font-medium flex items-center gap-1 transition ml-2 border border-green-500"
        title="Create new tab with current filters"
      >
        <Copy size={14} />
        Tab from Filter
      </button>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  activeTabId: PropTypes.string.isRequired,
  onTabSwitch: PropTypes.func.isRequired,
  onTabClose: PropTypes.func.isRequired,
  onCreateTabFromFilter: PropTypes.func.isRequired
};

export default Tabs;

